// Quem pode usar o dashboard: só DJ (role === "dj"). Cliente e superadmin ficam de fora,
// inclusive papéis que venham a existir no futuro (lista de permissão, não de bloqueio).
// O status da assinatura NÃO decide o acesso: "inactive" é o DJ free e entra normalmente.
//
// Isto é só a barreira de interface. Quem garante de fato é a API (rotas do DJ exigindo role dj).
export function getDashboardAccessError(profile) {
  if (!profile || typeof profile !== "object") return null;

  if (profile.role !== "dj") {
    return "Acesso restrito. Esta área é exclusiva para DJs.";
  }

  if (profile.subscription_status === "blocked") {
    return "Sua conta está bloqueada. Entre em contato com o suporte.";
  }

  return null;
}
